// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prehead[data-v-9261cfdc]{font-weight:700}[style*=\"--background-color\"][style*=\"--color\"] .prehead[data-v-9261cfdc]{color:var(--color)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
